import {createApi} from "@reduxjs/toolkit/query/react";
import {fetchBaseFPNetQuery} from "@commons/utils/fetchBaseFPNetQuery";
import {addBaseQueryParams, BaseQueryParams, transformResponse} from "@commons/utils/APIParams";
import {CCNLRecord} from "@commons/mapping/SettoriCCNL";
import {ContrattiCCNL} from "@commons/mapping/DataTablesSchema";
import {config} from "@commons/config.instance";

export interface TabellaCCNL extends BaseQueryParams {
    nowId: number | null,
}

export const ULTabellaCCNLApi = createApi({
    reducerPath: 'ULTabellaCCNLApi',
    baseQuery: fetchBaseFPNetQuery({baseUrl: config.getBaseUrl('FPNet')}),
    endpoints: (builder) => ({

        // TABELLA_CCNL http://fpnet.local/FPNet2021/sistema/unilav/ccnl?auth_token=6650c69d0d7376869fee12592d0ee5a0&nowId=1675157709764&mode=DataTables&nowId=1675157709764&view=Grid
        getTabellaCCNL: builder.query<ContrattiCCNL, Partial<TabellaCCNL>>({
            query: (filter) => {
                let params: string[] = addBaseQueryParams(filter);
                let url = `/sistema/unilav/ccnl`;
                return url + `${params.length > 0 ? '?' + encodeURI(params.join("&")) : ''}`;
            },
            transformResponse
        }),

        // SINGOLO_CCNL http://fpnet.local/FPNet2021/sistema/unilav/ccnl/*-001?auth_token=a09993dd79d700d37bf83cea58691f28&nowId=1675237636392
        getSingoloCCNL: builder.query<CCNLRecord, string>({
            query: (URI) => {
                return URI ? URI : `/${URI}`;
            },
            transformResponse
        }),

        deleteCCNL: builder.mutation<void, string>({
            query: (URI) => ({
                url: URI ? URI : '',
                method: 'DELETE'
            }),
        }),

        updateElemento: builder.mutation<Partial<CCNLRecord>, Partial<CCNLRecord> & Pick<CCNLRecord, 'URI'>>({
            // note: an optional `queryFn` may be used in place of `query`
            query: ({URI, ...patch}) => ({
                url: URI ? URI : '',
                method: 'PUT',
                body: patch,
            }),
            transformResponse,
        }),

        insertElemento: builder.mutation<Partial<CCNLRecord>, Partial<CCNLRecord>>({
            // note: an optional `queryFn` may be used in place of `query`
            query: (payload) => ({
                url: `/sistema/unilav/ccnl`,
                method: 'POST',
                body: payload,
            }),
            transformResponse
        }),
    }),
})

export const {
    useGetTabellaCCNLQuery,
    useInsertElementoMutation,
    useLazyGetSingoloCCNLQuery,
    useUpdateElementoMutation,
    useDeleteCCNLMutation,

} = ULTabellaCCNLApi;
